import { safeJsonParse } from '../utils/utils';
import { DOB_ERROR_MSG, DOB_LABELS } from './dateOfBirth';
import { IDENTITY_PAGE_TITLE } from '../constants';
import { ADDRESS_FORM_HELP_TEXT, ADDRESS_FORM_LABELS } from './addressInfo';
import { CONS } from './connectAnotherWay';
import { DEMOGRAPHIC_VALIDATION } from './demographic';
import {
  ERROR_LINK_TEXT,
  FORGOT_USERNAME_ERRORS,
  LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH,
  NO_MATCH_FOUND_TITLE_IDENTITY_INFO,
  OWN_INFO_ERROR_DESC1,
  OWN_INFO_ERROR_DESC2,
  OWN_INFO_ERROR_LINK,
  OWN_INFO_ERROR_TITLE,
  RX_MERGE_ERRORS,
  TECH_ERROR_DESC,
  TECH_ERROR_TITLE,
  TWO_ATTEMPTS_REMAINING_DESC,
  TWO_ATTEMPTS_REMAINING_PET_DESC,
  UNIFIED_REGISTRATION_ERRORS,
  UNLOCK_USER_ERRORS
} from './lookupErrors';

export const PAGE_TITLE = 'Enter their personal info';
export const PAGE_TYPE = 'identity-info';
export const TITLE_START = 'Let\'s get started';
export const TITLE_INFO = 'Enter your info';
export const TITLE_ADDRESS = 'Now, enter your address';
export const TITLE_MEMBERID = 'We need a little more info to find your records';
export const TITLE_ALL = 'Check your info one more time';
export const TITLE_ALL_v2 = 'Check your info again';
export const TITLE_PERSONAL_INFO = 'Personal info';
export const TITLE_ADDRESS_INFO = 'Address info';
export const TITLE_ONLYDOBTITLE = 'Check your date of birth again';
export const DESCRIPTION_INFO = 'We’ll use it to look for your records.';
export const DESCRIPTION_ADDRESS = 'We’ll combine it with your other info to search for your records.';
export const DESCRIPTION_ALL = 'Make sure the info entered matches what we have on file.';
export const DESCRIPTION_ONLYDOB = `We're having trouble locating you in our system. Please re-enter your date of birth.`;
export const ALL_FIELDS_REQUIRED = 'All fields are required.';
export const ALL_FIELDS_REQUIRED_WITH_OPTIONAL = 'All fields required unless marked optional.';
export const CONTINUE_BUTTON_TEXT = 'Continue';
export const SUBMIT_BUTTON_TEXT = 'Search';
export const CANCEL_BUTTON_TEXT = 'Cancel';
export const MATCH_NOT_FOUND = 'We haven’t found a match yet';
export const NO_MATCH = 'No match found';
export const LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH =
  'You can search 1 more time.\n\nIf we don’t find a match, you’ll have to wait 15 minutes to try again.';
export const HELP = 'Need help?';
export const HELP_CENTER = 'Help center';
export const EMAIL_ADDRESS_LABEL = 'Email address';

export const MODAL = {
  HEADER: 'You must be 18 or older',
  PARAGRAPH: 'Only adults can connect records.',
  PARAGRAPH2: 'Trying to manage care for someone else? First, connect your own records. Then, you can ',
  ADDMANAGEPEOPLE: 'add and manage people',
  PARAGRAPH2CONTINUE: ' on your account.',
  CUSTOMERCARE: 'If you need help. call us at ',
  CUSTOMERCARENUMBER: '1-888-607-4287',
  TTY: ' (TTY: ',
  TTYNo: '711)',
  OK: 'Ok'
};

export const VERIFICATION_MODAL = {
  HEADER: 'Why we\'re verifying your phone number',
  BODY:
    'We use your phone number and other info to verify your identity. This helps us keep your account secure and protect your privacy.'
};

export const IDENTITY_INFO_FORM_LABELS = {
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  DATE_OF_BIRTH: 'Date of birth',
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
  PHONE_NUMBER: 'Phone number',
  MOBILE_NUMBER: 'Mobile number',
  STREET_ADDRESS: 'Street address',
  UNIT: 'Unit, apartment, etc. (optional) ',
  CITY: 'City',
  STATE: 'State',
  ZIP_CODE: 'ZIP code',
  MEMBER_ID: 'Member ID (optional)'
};

export const SPECIALTY_IDENTITY_INFO_FORM_LABELS = {
  FIRST_NAME: 'Patient first name',
  LAST_NAME: 'Patient last name',
  DATE_OF_BIRTH: 'Patient date of birth'
};

export const IDENTITY_INFO_ERROR_TITLES = {
  DEFAULT: 'We need you to check something'
};

export const IDENTITY_IMPORTANT_NOTE_BANNER = {
  TITLE: ' The account with that username has been deleted. You can register now with a new one.'
};

export const PERSONAL_INFO_VALIDATION = {
  FIRST_NAME_REQUIRED: 'Enter a first name',
  FIRST_NAME_INVALID: 'First name cannot exceed 40 characters',
  LAST_NAME_REQUIRED: 'Enter a last name',
  LAST_NAME_INVALID: 'Last name cannot exceed 40 characters',
  DATE_OF_BIRTH_REQUIRED: 'Enter an 8-digit date of birth',
  DATE_OF_BIRTH_INVALID: 'Enter a valid 8-digit date of birth',
  PHONE_NUMBER_REQUIRED: 'Enter a 10-digit phone number',
  PHONE_NUMBER_INVALID: 'Enter a valid 10-digit phone number\n',
  STREET_ADDRESS_REQUIRED: 'Enter a street address',
  STREET_ADDRESS_INVALID: 'Street address cannot exceed 40 characters',
  UNIT_INVALID: 'Unit, apartment, etc. (optional) cannot exceed 40 characters',
  CITY_REQUIRED: 'Enter a city',
  STATE_REQUIRED: 'Select a 2-character abbreviated state',
  STATE_INVALID: 'Select a valid 2-character abbreviated state',
  ZIP_CODE_REQUIRED: 'Enter a 5-digit ZIP code',
  ZIP_CODE_INVALID: 'Enter a valid 5-digit ZIP code',
  MEMBER_ID_INVALID: 'Member ID cannot include special characters'
};
export const DOB_VALIDATION = {
  DATE_OF_BIRTH_REQUIRED: 'Enter your date of birth',
  DOB_REQ: ['Enter your birth month', 'Enter your birth day', 'Enter your birth year', 'Enter your date of birth'],
  DATE_OF_BIRTH_REQUIRED_ALERT_FIELD: 'Enter your date of birth',
  DATE_OF_BIRTH_INVALID: 'Enter the date of birth as: \nMM/DD/YYYY',
  DATE_OF_BIRTH_FUTURE_ALERT_FIELD: 'Enter a valid date of birth',
  DATE_OF_BIRTH_FUTURE: 'Future dates are not valid',
  DATE_OF_BIRTH_MINOR: 'Enter a date of birth at least 18 years in the past',
  ZIP_CODE_REQUIRED: 'Enter your ZIP code',
  ZIP_CODE_INVALID: 'Enter a valid ZIP code'
};

export const IDENTITY_INFO_FORM_HELP_TEXT = {
  DATE_OF_BIRTH: 'MMDDYYYY',
  DAY: 'Day',
  MONTH: 'Month',
  YEAR: 'Year',
  PHONE_NUMBER: 'Enter the number on file with \n the pharmacy.',
  MEMBER_ID: 'Your Member ID number can be found on your prescription or insurance card'
};

export const IDENTITYINFO_FORM_HELP_TEXT = {
  DATE_OF_BIRTH: 'MMDDYYYY',
  PHONE_NUMBER: 'Enter the number on file with the pharmacy.',
  SECOND_ATTEMPT: {
    DATE_OF_BIRTH: 'Patient’s date of birth \n MMDDYYYY'
  }
};

// i18n Translation Configuration
export const IDENTITY_INFO_TRANSLATION_CONFIG = [
  { key: 'PAGE_TITLE', value: PAGE_TITLE, message: PAGE_TITLE },
  { key: 'TITLE_START', value: TITLE_START, message: TITLE_START },
  { key: 'TITLE_ONLYDOBTITLE', value: TITLE_ONLYDOBTITLE, message: TITLE_ONLYDOBTITLE },
  { key: 'TITLE_INFO', value: TITLE_INFO, message: TITLE_INFO },
  { key: 'TITLE_ADDRESS', value: TITLE_ADDRESS, message: TITLE_ADDRESS },
  { key: 'TITLE_MEMBERID', value: TITLE_MEMBERID, message: TITLE_MEMBERID },
  { key: 'TITLE_ALL', value: TITLE_ALL, message: TITLE_ALL },
  { key: 'TITLE_ALL_v2', value: TITLE_ALL_v2, message: TITLE_ALL_v2 },
  { key: 'TITLE_PERSONAL_INFO', value: TITLE_PERSONAL_INFO, message: TITLE_PERSONAL_INFO },
  { key: 'TITLE_ADDRESS_INFO', value: TITLE_ADDRESS_INFO, message: TITLE_ADDRESS_INFO },
  { key: 'DESCRIPTION_INFO', value: DESCRIPTION_INFO, message: DESCRIPTION_INFO },
  { key: 'DESCRIPTION_ADDRESS', value: DESCRIPTION_ADDRESS, message: DESCRIPTION_ADDRESS },
  { key: 'DESCRIPTION_ALL', value: DESCRIPTION_ALL, message: DESCRIPTION_ALL },
  { key: 'DESCRIPTION_ONLYDOB', value: DESCRIPTION_ONLYDOB, message: DESCRIPTION_ONLYDOB },
  { key: 'ALL_FIELDS_REQUIRED', value: ALL_FIELDS_REQUIRED, message: ALL_FIELDS_REQUIRED },
  {
    key: 'ALL_FIELDS_REQUIRED_WITH_OPTIONAL',
    value: ALL_FIELDS_REQUIRED_WITH_OPTIONAL,
    message: ALL_FIELDS_REQUIRED_WITH_OPTIONAL
  },
  { key: 'CONTINUE_BUTTON_TEXT', value: CONTINUE_BUTTON_TEXT, message: CONTINUE_BUTTON_TEXT },
  { key: 'SUBMIT_BUTTON_TEXT', value: SUBMIT_BUTTON_TEXT, message: SUBMIT_BUTTON_TEXT },
  { key: 'CANCEL_BUTTON_TEXT', value: CANCEL_BUTTON_TEXT, message: CANCEL_BUTTON_TEXT },
  { key: 'MATCH_NOT_FOUND', value: MATCH_NOT_FOUND, message: MATCH_NOT_FOUND },
  { key: 'NO_MATCH', value: NO_MATCH, message: NO_MATCH },
  {
    key: 'LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH',
    value: LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH,
    message: LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH
  },
  { key: 'MODAL', value: JSON.stringify(MODAL), message: JSON.stringify(MODAL) },
  { key: 'VERIFICATION_MODAL', value: JSON.stringify(VERIFICATION_MODAL), message: JSON.stringify(VERIFICATION_MODAL) },
  {
    key: 'IDENTITY_INFO_FORM_LABELS',
    value: JSON.stringify(IDENTITY_INFO_FORM_LABELS),
    message: JSON.stringify(IDENTITY_INFO_FORM_LABELS)
  },
  {
    key: 'SPECIALTY_IDENTITY_INFO_FORM_LABELS',
    value: JSON.stringify(SPECIALTY_IDENTITY_INFO_FORM_LABELS),
    message: JSON.stringify(SPECIALTY_IDENTITY_INFO_FORM_LABELS)
  },
  {
    key: 'IDENTITY_INFO_ERROR_TITLES',
    value: JSON.stringify(IDENTITY_INFO_ERROR_TITLES),
    message: JSON.stringify(IDENTITY_INFO_ERROR_TITLES)
  },
  {
    key: 'IDENTITY_IMPORTANT_NOTE_BANNER',
    value: JSON.stringify(IDENTITY_IMPORTANT_NOTE_BANNER),
    message: JSON.stringify(IDENTITY_IMPORTANT_NOTE_BANNER)
  },
  {
    key: 'PERSONAL_INFO_VALIDATION',
    value: JSON.stringify(PERSONAL_INFO_VALIDATION),
    message: JSON.stringify(PERSONAL_INFO_VALIDATION)
  },
  { key: 'DOB_LABELS', value: JSON.stringify(DOB_LABELS), message: JSON.stringify(DOB_LABELS) },
  { key: 'DOB_VALIDATION', value: JSON.stringify(DOB_VALIDATION), message: JSON.stringify(DOB_VALIDATION) },
  { key: 'DOB_ERROR_MSG', value: JSON.stringify(DOB_ERROR_MSG), message: JSON.stringify(DOB_ERROR_MSG) },
  {
    key: 'IDENTITY_INFO_FORM_HELP_TEXT',
    value: JSON.stringify(IDENTITY_INFO_FORM_HELP_TEXT),
    message: JSON.stringify(IDENTITY_INFO_FORM_HELP_TEXT)
  },
  {
    key: 'IDENTITYINFO_FORM_HELP_TEXT',
    value: JSON.stringify(IDENTITYINFO_FORM_HELP_TEXT),
    message: JSON.stringify(IDENTITYINFO_FORM_HELP_TEXT)
  },
  { key: 'EMAIL_ADDRESS_LABEL', value: EMAIL_ADDRESS_LABEL, message: EMAIL_ADDRESS_LABEL },
  { key: 'HELP', value: HELP, message: HELP },
  { key: 'HELP_CENTER', value: HELP_CENTER, message: HELP_CENTER },
  { key: 'IDENTITY_PAGE_TITLE', value: IDENTITY_PAGE_TITLE, message: IDENTITY_PAGE_TITLE },
  {
    key: 'ADDRESS_FORM_LABELS',
    value: JSON.stringify(ADDRESS_FORM_LABELS),
    message: JSON.stringify(ADDRESS_FORM_LABELS)
  },
  {
    key: 'ADDRESS_FORM_HELP_TEXT',
    value: JSON.stringify(ADDRESS_FORM_HELP_TEXT),
    message: JSON.stringify(ADDRESS_FORM_HELP_TEXT)
  },
  { key: 'TECH_ERROR_TITLE', value: TECH_ERROR_TITLE, message: TECH_ERROR_TITLE },
  { key: 'TECH_ERROR_DESC', value: TECH_ERROR_DESC, message: TECH_ERROR_DESC },
  {
    key: 'NO_MATCH_FOUND_TITLE_IDENTITY_INFO',
    value: NO_MATCH_FOUND_TITLE_IDENTITY_INFO,
    message: NO_MATCH_FOUND_TITLE_IDENTITY_INFO
  },
  {
    key: 'LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH',
    value: LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH,
    message: LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH
  },
  { key: 'OWN_INFO_ERROR_TITLE', value: OWN_INFO_ERROR_TITLE, message: OWN_INFO_ERROR_TITLE },
  { key: 'OWN_INFO_ERROR_DESC1', value: OWN_INFO_ERROR_DESC1, message: OWN_INFO_ERROR_DESC1 },
  { key: 'OWN_INFO_ERROR_DESC2', value: OWN_INFO_ERROR_DESC2, message: OWN_INFO_ERROR_DESC2 },
  { key: 'OWN_INFO_ERROR_LINK', value: OWN_INFO_ERROR_LINK, message: OWN_INFO_ERROR_LINK },
  {
    key: 'TWO_ATTEMPTS_REMAINING_DESC',
    value: TWO_ATTEMPTS_REMAINING_DESC,
    message: TWO_ATTEMPTS_REMAINING_DESC
  },
  {
    key: 'TWO_ATTEMPTS_REMAINING_PET_DESC',
    value: TWO_ATTEMPTS_REMAINING_PET_DESC,
    message: TWO_ATTEMPTS_REMAINING_PET_DESC
  },
  {
    key: 'TRY_PERSONAL_INFO',
    value: ERROR_LINK_TEXT.TRY_PERSONAL_INFO,
    message: ERROR_LINK_TEXT.TRY_PERSONAL_INFO
  },
  {
    key: 'TRY_PRESCRIPTION_LABEL',
    value: ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL,
    message: ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL
  },
  {
    key: 'ENTER_PRESCRIPTION_AGAIN',
    value: ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN,
    message: ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN
  },
  {
    key: 'ENTER_PERSONAL_INFO_AGAIN',
    value: ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN,
    message: ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN
  },
  {
    key: 'UNIFIED_REGISTRATION_ERRORS',
    value: JSON.stringify(UNIFIED_REGISTRATION_ERRORS),
    message: JSON.stringify(UNIFIED_REGISTRATION_ERRORS)
  },
  {
    key: 'RX_MERGE_ERRORS',
    value: JSON.stringify(RX_MERGE_ERRORS),
    message: JSON.stringify(RX_MERGE_ERRORS)
  },
  {
    key: 'FORGOT_USERNAME_ERRORS',
    value: JSON.stringify(FORGOT_USERNAME_ERRORS),
    message: JSON.stringify(FORGOT_USERNAME_ERRORS)
  },
  {
    key: 'UNLOCK_USER_ERRORS',
    value: JSON.stringify(UNLOCK_USER_ERRORS),
    message: JSON.stringify(UNLOCK_USER_ERRORS)
  },
  {
    key: 'DEMOGRAPHIC_VALIDATION',
    value: JSON.stringify(DEMOGRAPHIC_VALIDATION),
    message: JSON.stringify(DEMOGRAPHIC_VALIDATION)
  },
  {
    key: 'MEMBER_ID_MODAL',
    value: JSON.stringify(CONS.MEMBER_ID_MODAL),
    message: JSON.stringify(CONS.MEMBER_ID_MODAL)
  }
];

// Process translated items for identity-info page
export const processIdentityInfoTranslations = (translatedItems: Record<string, string>) => {
  if (!translatedItems || Object.keys(translatedItems).length === 0) {
    translatedItems = {};
  }

  // Destructure simple string values with fallbacks
  const {
    [PAGE_TITLE]: PAGE_TITLE_TRANSLATED = PAGE_TITLE,
    [TITLE_START]: TITLE_START_TRANSLATED = TITLE_START,
    [TITLE_ONLYDOBTITLE]: TITLE_ONLYDOBTITLE_TRANSLATED = TITLE_ONLYDOBTITLE,
    [TITLE_INFO]: TITLE_INFO_TRANSLATED = TITLE_INFO,
    [TITLE_PERSONAL_INFO]: TITLE_PERSONAL_INFO_TRANSLATED = TITLE_PERSONAL_INFO,
    [TITLE_ADDRESS]: TITLE_ADDRESS_TRANSLATED = TITLE_ADDRESS,
    [TITLE_ADDRESS_INFO]: TITLE_ADDRESS_INFO_TRANSLATED = TITLE_ADDRESS_INFO,
    [TITLE_MEMBERID]: TITLE_MEMBERID_TRANSLATED = TITLE_MEMBERID,
    [TITLE_ALL]: TITLE_ALL_TRANSLATED = TITLE_ALL,
    [TITLE_ALL_v2]: TITLE_ALL_v2_TRANSLATED = TITLE_ALL_v2,
    [DESCRIPTION_INFO]: DESCRIPTION_INFO_TRANSLATED = DESCRIPTION_INFO,
    [DESCRIPTION_ADDRESS]: DESCRIPTION_ADDRESS_TRANSLATED = DESCRIPTION_ADDRESS,
    [DESCRIPTION_ALL]: DESCRIPTION_ALL_TRANSLATED = DESCRIPTION_ALL,
    [DESCRIPTION_ONLYDOB]: DESCRIPTION_ONLYDOB_TRANSLATED = DESCRIPTION_ONLYDOB,
    [ALL_FIELDS_REQUIRED]: ALL_FIELDS_REQUIRED_TRANSLATED = ALL_FIELDS_REQUIRED,
    [ALL_FIELDS_REQUIRED_WITH_OPTIONAL]: ALL_FIELDS_REQUIRED_WITH_OPTIONAL_TRANSLATED = ALL_FIELDS_REQUIRED_WITH_OPTIONAL,
    [CONTINUE_BUTTON_TEXT]: CONTINUE_BUTTON_TEXT_TRANSLATED = CONTINUE_BUTTON_TEXT,
    [SUBMIT_BUTTON_TEXT]: SUBMIT_BUTTON_TEXT_TRANSLATED = SUBMIT_BUTTON_TEXT,
    [CANCEL_BUTTON_TEXT]: CANCEL_BUTTON_TEXT_TRANSLATED = CANCEL_BUTTON_TEXT,
    [MATCH_NOT_FOUND]: MATCH_NOT_FOUND_TRANSLATED = MATCH_NOT_FOUND,
    [NO_MATCH]: NO_MATCH_TRANSLATED = NO_MATCH,
    [LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH]: LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH_TRANSLATED = LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH,
    [EMAIL_ADDRESS_LABEL]: EMAIL_ADDRESS_LABEL_TRANSLATED = EMAIL_ADDRESS_LABEL,
    [HELP]: HELP_TRANSLATED = HELP,
    [HELP_CENTER]: HELP_CENTER_TRANSLATED = HELP_CENTER,
    [IDENTITY_PAGE_TITLE]: IDENTITY_PAGE_TITLE_TRANSLATED = IDENTITY_PAGE_TITLE
  } = translatedItems;

  return {
    PAGE_TYPE: PAGE_TYPE,
    PAGE_TITLE: PAGE_TITLE_TRANSLATED,
    TITLE_START: TITLE_START_TRANSLATED,
    TITLE_ONLYDOBTITLE: TITLE_ONLYDOBTITLE_TRANSLATED,
    TITLE_INFO: TITLE_INFO_TRANSLATED,
    TITLE_PERSONAL_INFO: TITLE_PERSONAL_INFO_TRANSLATED,
    TITLE_ADDRESS: TITLE_ADDRESS_TRANSLATED,
    TITLE_ADDRESS_INFO: TITLE_ADDRESS_INFO_TRANSLATED,
    TITLE_MEMBERID: TITLE_MEMBERID_TRANSLATED,
    TITLE_ALL: TITLE_ALL_TRANSLATED,
    TITLE_ALL_v2: TITLE_ALL_v2_TRANSLATED,
    DESCRIPTION_INFO: DESCRIPTION_INFO_TRANSLATED,
    DESCRIPTION_ADDRESS: DESCRIPTION_ADDRESS_TRANSLATED,
    DESCRIPTION_ALL: DESCRIPTION_ALL_TRANSLATED,
    DESCRIPTION_ONLYDOB: DESCRIPTION_ONLYDOB_TRANSLATED,
    ALL_FIELDS_REQUIRED: ALL_FIELDS_REQUIRED_TRANSLATED,
    ALL_FIELDS_REQUIRED_WITH_OPTIONAL: ALL_FIELDS_REQUIRED_WITH_OPTIONAL_TRANSLATED,
    CONTINUE_BUTTON_TEXT: CONTINUE_BUTTON_TEXT_TRANSLATED,
    SUBMIT_BUTTON_TEXT: SUBMIT_BUTTON_TEXT_TRANSLATED,
    CANCEL_BUTTON_TEXT: CANCEL_BUTTON_TEXT_TRANSLATED,
    MATCH_NOT_FOUND: MATCH_NOT_FOUND_TRANSLATED,
    NO_MATCH: NO_MATCH_TRANSLATED,
    LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH: LAST_FAILED_ATTEMPTS_DESC_DEMO_SEARCH_TRANSLATED,
    EMAIL_ADDRESS_LABEL: EMAIL_ADDRESS_LABEL_TRANSLATED,
    HELP: HELP_TRANSLATED,
    HELP_CENTER: HELP_CENTER_TRANSLATED,
    IDENTITY_PAGE_TITLE: IDENTITY_PAGE_TITLE_TRANSLATED,
    // Keep safeJsonParse for complex objects that need JSON parsing
    MODAL: safeJsonParse(translatedItems[JSON.stringify(MODAL)], MODAL),
    VERIFICATION_MODAL: safeJsonParse(translatedItems[JSON.stringify(VERIFICATION_MODAL)], VERIFICATION_MODAL),
    IDENTITY_INFO_FORM_LABELS: safeJsonParse(
      translatedItems[JSON.stringify(IDENTITY_INFO_FORM_LABELS)],
      IDENTITY_INFO_FORM_LABELS
    ),
    SPECIALTY_IDENTITY_INFO_FORM_LABELS: safeJsonParse(
      translatedItems[JSON.stringify(SPECIALTY_IDENTITY_INFO_FORM_LABELS)],
      SPECIALTY_IDENTITY_INFO_FORM_LABELS
    ),
    IDENTITY_INFO_ERROR_TITLES: safeJsonParse(
      translatedItems[JSON.stringify(IDENTITY_INFO_ERROR_TITLES)],
      IDENTITY_INFO_ERROR_TITLES
    ),
    IDENTITY_IMPORTANT_NOTE_BANNER: safeJsonParse(
      translatedItems[JSON.stringify(IDENTITY_IMPORTANT_NOTE_BANNER)],
      IDENTITY_IMPORTANT_NOTE_BANNER
    ),
    PERSONAL_INFO_VALIDATION: safeJsonParse(
      translatedItems[JSON.stringify(PERSONAL_INFO_VALIDATION)],
      PERSONAL_INFO_VALIDATION
    ),
    DOB_LABELS: safeJsonParse(translatedItems[JSON.stringify(DOB_LABELS)], DOB_LABELS),
    DOB_VALIDATION: safeJsonParse(translatedItems[JSON.stringify(DOB_VALIDATION)], DOB_VALIDATION),
    DOB_ERROR_MSG: safeJsonParse(translatedItems[JSON.stringify(DOB_ERROR_MSG)], DOB_ERROR_MSG),
    TECH_ERROR_TITLE: translatedItems[TECH_ERROR_TITLE] || TECH_ERROR_TITLE,
    TECH_ERROR_DESC: translatedItems[TECH_ERROR_DESC] || TECH_ERROR_DESC,
    NO_MATCH_FOUND_TITLE_IDENTITY_INFO:
      translatedItems[NO_MATCH_FOUND_TITLE_IDENTITY_INFO] || NO_MATCH_FOUND_TITLE_IDENTITY_INFO,
    LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH:
      translatedItems[LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH] || LAST_FAILED_ATTEMPTS_DESC_IDENTITY_INFO_SEARCH,
    OWN_INFO_ERROR_TITLE: translatedItems[OWN_INFO_ERROR_TITLE] || OWN_INFO_ERROR_TITLE,
    OWN_INFO_ERROR_DESC1: translatedItems[OWN_INFO_ERROR_DESC1] || OWN_INFO_ERROR_DESC1,
    OWN_INFO_ERROR_DESC2: translatedItems[OWN_INFO_ERROR_DESC2] || OWN_INFO_ERROR_DESC2,
    OWN_INFO_ERROR_LINK: translatedItems[OWN_INFO_ERROR_LINK] || OWN_INFO_ERROR_LINK,
    TWO_ATTEMPTS_REMAINING_DESC: translatedItems[TWO_ATTEMPTS_REMAINING_DESC] || TWO_ATTEMPTS_REMAINING_DESC,
    TWO_ATTEMPTS_REMAINING_PET_DESC:
      translatedItems[TWO_ATTEMPTS_REMAINING_PET_DESC] || TWO_ATTEMPTS_REMAINING_PET_DESC,
    TRY_PERSONAL_INFO: translatedItems[ERROR_LINK_TEXT.TRY_PERSONAL_INFO] || ERROR_LINK_TEXT.TRY_PERSONAL_INFO,
    TRY_PRESCRIPTION_LABEL:
      translatedItems[ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL] || ERROR_LINK_TEXT.TRY_PRESCRIPTION_LABEL,
    ENTER_PRESCRIPTION_AGAIN:
      translatedItems[ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN] || ERROR_LINK_TEXT.ENTER_PRESCRIPTION_AGAIN,
    ENTER_PERSONAL_INFO_AGAIN:
      translatedItems[ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN] || ERROR_LINK_TEXT.ENTER_PERSONAL_INFO_AGAIN,
    IDENTITY_INFO_FORM_HELP_TEXT: safeJsonParse(
      translatedItems[JSON.stringify(IDENTITY_INFO_FORM_HELP_TEXT)],
      IDENTITY_INFO_FORM_HELP_TEXT
    ),
    IDENTITYINFO_FORM_HELP_TEXT: safeJsonParse(
      translatedItems[JSON.stringify(IDENTITYINFO_FORM_HELP_TEXT)],
      IDENTITYINFO_FORM_HELP_TEXT
    ),
    ADDRESS_FORM_LABELS: safeJsonParse(translatedItems[JSON.stringify(ADDRESS_FORM_LABELS)], ADDRESS_FORM_LABELS),
    ADDRESS_FORM_HELP_TEXT: safeJsonParse(
      translatedItems[JSON.stringify(ADDRESS_FORM_HELP_TEXT)],
      ADDRESS_FORM_HELP_TEXT
    ),
    UNIFIED_REGISTRATION_ERRORS: safeJsonParse(
      translatedItems[JSON.stringify(UNIFIED_REGISTRATION_ERRORS)],
      UNIFIED_REGISTRATION_ERRORS
    ),
    DEMOGRAPHIC_VALIDATION: safeJsonParse(
      translatedItems[JSON.stringify(DEMOGRAPHIC_VALIDATION)],
      DEMOGRAPHIC_VALIDATION
    ),
    MEMBER_ID_MODAL: safeJsonParse(translatedItems[JSON.stringify(CONS.MEMBER_ID_MODAL)], CONS.MEMBER_ID_MODAL),
    RX_MERGE_ERRORS: safeJsonParse(translatedItems[JSON.stringify(RX_MERGE_ERRORS)], RX_MERGE_ERRORS),
    FORGOT_USERNAME_ERRORS: safeJsonParse(
      translatedItems[JSON.stringify(FORGOT_USERNAME_ERRORS)],
      FORGOT_USERNAME_ERRORS
    ),
    UNLOCK_USER_ERRORS: safeJsonParse(translatedItems[JSON.stringify(UNLOCK_USER_ERRORS)], UNLOCK_USER_ERRORS)
  };
};
